import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import Icon from '../components/Icon';
import Reveal from '../components/Reveal';
import PageHero from '../components/PageHero';
import ProjectPreview from '../components/ProjectPreview';
import CTA from '../components/CTA';
import projects from '../data/portfolio';
import './Portfolio.css';

const Portfolio = () => {
  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'CollectionPage',
    name: 'ESCR LLC Portfolio',
    description: 'Portfolio of web development, mobile applications, and software solutions created by ESCR LLC',
    url: 'https://escr.online/portfolio'
  };

  return (
    <div className="portfolio">
      <SEO
        title="Portfolio"
        description="View our portfolio of web development projects, mobile applications, and software solutions. See examples of our work and client success stories."
        keywords="portfolio, web development projects, mobile apps, software solutions, ESCR LLC work examples"
        structuredData={structuredData}
      />

      <PageHero
        eyebrow="Selected work"
        title="Products we've shipped."
        subtitle="Showcasing innovative software solutions and successful projects."
      />

      <section className="section section-tight">
        <div className="container">
          <div className="work-list">
            {projects.map((project, i) => (
              <Reveal key={project.id} delay={i * 80}>
                <Link to={`/portfolio/${project.id}`} className="card work-card" aria-label={`View details for ${project.title}`}>
                  <div className="work-visual">
                    <ProjectPreview project={project} />
                  </div>
                  <div className="work-body">
                    <div className="work-meta">
                      {project.featured && <span className="tag tag-accent">Featured</span>}
                      <span className="tag">{project.category}</span>
                      <span className="tag">{project.date}</span>
                    </div>
                    <h2 className="work-title">{project.title}</h2>
                    <p className="work-desc">{project.description}</p>
                    <div className="work-tech">
                      {project.technologies.map((tech) => (
                        <span key={tech} className="work-tech-item">
                          {tech}
                        </span>
                      ))}
                    </div>
                    <span className="link-arrow">
                      View project <Icon name="arrowRight" />
                    </span>
                  </div>
                </Link>
              </Reveal>
            ))}

            <Reveal delay={projects.length * 80}>
              <Link to="/contact" className="work-next">
                <span className="work-next-plus">
                  <Icon name="plus" />
                </span>
                <span className="work-next-title">Your project could be next.</span>
                <span className="work-next-sub">Tell us what you're building</span>
              </Link>
            </Reveal>
          </div>
        </div>
      </section>

      <CTA secondary={{ to: '/about', label: 'About ESCR' }} />
    </div>
  );
};

export default Portfolio;
